import { Box, Chip, Stack, Tab, Tabs } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import { hasPermission } from 'store'
import { searchPendingApprovals } from 'store/leave/leave-request'
import { search as searchPunchApprovals } from 'store/leave/punch-request'
import 'utils/global.scss'

export const tabConfig = [
  {
    index: 0,
    label: 'Leave Requests',
    path: 'request',
    permission: 'leave.leave',
    badge: false,
  },
  {
    index: 1,
    label: 'Leave Approvals',
    path: 'leave-approvals',
    permission: 'leave.request',
    badge: true,
  },
  {
    index: 2,
    label: 'Punch Records',
    path: 'punch-records',
    permission: 'leave.leave',
    badge: false,
  },
  {
    index: 3,
    label: 'Punch Approvals',
    path: 'punch-approvals',
    permission: 'leave.punch',
    badge: true,
  },
]

export default function SchedulingTabs() {
  const { t } = useTranslation()
  const theme = useSelector(state => state.session.appearance)
  const { '*': tabName } = useParams()
  const dispatch = useDispatch()

  const pendingApprovals = useSelector(state => state.leave.leaveRequest.pendingApprovals)
  const pendingCount = useSelector(state => state.leave.leaveRequest.pendingCount)
  const punchRequestList = useSelector(state => state.leave.punchRequest.list)
  const punchCount = punchRequestList?.length ?? 0

  const permittedTabs = tabConfig.filter(tab => hasPermission(tab.permission))

  const getTabIndex = path => {
    const [tabName] = path.split('/')
    const found = permittedTabs.find(tab => tab.path === tabName)
    return found ? found.index : permittedTabs[0]?.index ?? 0
  }
  const [tabIndex, setTabIndex] = useState(getTabIndex(tabName))

  useEffect(() => {
    setTabIndex(getTabIndex(tabName))
  }, [tabName, permittedTabs.length])

  useEffect(() => {
    if (!hasPermission('leave.request') && !hasPermission('hr.leave')) return
    pendingApprovals || dispatch(searchPendingApprovals())
  }, [dispatch, Boolean(pendingCount), Boolean(pendingApprovals)])

  useEffect(() => {
    if (!hasPermission('leave.punch')) return
    punchRequestList || dispatch(searchPunchApprovals())
  }, [dispatch, Boolean(punchRequestList)])

  const badgeCounts = {
    1: pendingCount,
    3: punchCount,
  }

  const basePath = `/leave-request`

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', displayPrint: 'none' }}>
      <Tabs value={tabIndex}>
        {permittedTabs.map(tab => {
          const count = badgeCounts[tab.index]
          return (
            <Tab
              key={tab.path}
              sx={{ color: tabIndex === tab.index && 'primary !important' }}
              className={tabIndex === tab.index ? 'tab-item-selected' : `tab-item-${theme}`}
              label={
                tab.badge && count > 0 ? (
                  <Stack direction="row" alignItems="center" spacing={0.75}>
                    <span>{t(tab.label)}</span>
                    <Chip
                      label={count}
                      color="error"
                      size="small"
                      sx={{ height: 18, minWidth: 18, fontSize: 11, '& .MuiChip-label': { px: 0.75 } }}
                    />
                  </Stack>
                ) : (
                  t(tab.label)
                )
              }
              value={tab.index}
              component={Link}
              to={`${basePath}/${tab.path}`}
              disabled={tab.disabled}
            />
          )
        })}
      </Tabs>
    </Box>
  )
}
